import { CustomerHeader } from "@/components/CustomerHeader/CustomerHeader";
import { useAuthenticatedRoute } from "@/context/authenticated-route";
import { useSettings } from "@/context/settings";
import { useSystem } from "@/context/system";
import { SystemNotification } from "../SystemNotification/SystemNotification";
import css from "./CustomerLayout.module.scss";

type Props = {
  children?: React.ReactNode;
};

export function CustomerLayout(props: Props) {
  const { children } = props;
  const { notifications } = useSystem();
  const { customer } = useSettings();
  const { authenticatedRouteType } = useAuthenticatedRoute();

  const validNotifications = notifications.filter((notification) => notification.audience === authenticatedRouteType);

  return (
    <div className={css.root}>
      <div className={css.top}>
        {validNotifications.length > 0 &&
          validNotifications.map((notification, i) => (
            <SystemNotification notification={notification} key={`system-notification-${i}`} />
          ))}
        <CustomerHeader customer={customer.key} />
      </div>

      <div>{children}</div>
    </div>
  );
}
